import codesToFilter from './codesToFilter';
import typesToFilter from './typesToFilter';
import merchantToFilter from './merchantToFilter';

export default [
    {
        id: 0,
        value: {
            description: 'code',
            type: 'select',
            id: 1,
            data: codesToFilter,
            isIndexed: true,
            operator: 'equal',
            label: 'code'
        },
        label: 'Por código'
    },
    {
        id: 1,
        value: {
            description: 'id_creditcard_movement_type',
            type: 'select',
            id: 1,
            data: typesToFilter,
            isIndexed: true,
            operator: 'equal',
            label: 'id_creditcard_movement_type'
        },
        label: 'Por tipo'
    },
    {
        id: 2,
        value: {
            description: 'merchant_description',
            type: 'select',
            id: 1,
            data: merchantToFilter,
            isIndexed: true,
            operator: 'like',
            label: 'merchant_description'
        },
        label: 'Por comercio'
    },
];
